import { useEffect } from 'react'

import { useBulkSelector } from '~/shared/hooks/useBulkSelector'
import { selectFacebookPixelIds } from '~/shared/store/common/selects'
import {
  selectUserCountryCode,
  selectUserUUID,
} from '~/shared/store/user/selects'

const useSelectors = () =>
  useBulkSelector({
    uuid: selectUserUUID,
    facebookPixelIds: selectFacebookPixelIds,
    userCountryCode: selectUserCountryCode,
  })

export const useFacebookPixelInitialization = (): void => {
  const { uuid, facebookPixelIds, userCountryCode } = useSelectors()
  const isUnsubscribePath = window.location.pathname.includes('/unsubscribe')

  useEffect(() => {
    if (isUnsubscribePath || window.fbq) return

    const loadFacebookPixel = async () => {
      const script = document.createElement('script')
      script.async = true
      script.text = `!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');`
      document.body.appendChild(script)
    }

    loadFacebookPixel()
  }, [isUnsubscribePath])

  useEffect(() => {
    if (!window.fbq || !facebookPixelIds.length || !uuid || !userCountryCode) {
      return
    }

    facebookPixelIds.forEach((facebookPixelId) => {
      window.fbq('init', facebookPixelId, { external_id: uuid })
    })

    window.fbq('track', 'PageView')
  }, [facebookPixelIds, uuid, userCountryCode])
}
